import { render, staticRenderFns } from "./VWidget.vue?vue&type=template&id=896a2a48&scoped=true&"
import script from "./VWidget.vue?vue&type=script&lang=js&"
export * from "./VWidget.vue?vue&type=script&lang=js&"
import style0 from "./VWidget.vue?vue&type=style&index=0&id=896a2a48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../boss_taobao/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "896a2a48",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../boss_taobao/admin/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAppBar,VCard,VCardText,VDivider,VSpacer,VToolbarTitle})
